import { CareerPageForm } from "../Form/CareerPageForm";
import { LabelButton } from "../buttons/LabelButton/LabelButton";
import "./formSections.css";

export const CareerFormSection = () => {
  return (
    <div className="feedback">
      <div className="feedback-left-side">
        <LabelButton>GET IN TOUCH</LabelButton>
        <div className="career-form">
          <p className="description-medium">
            Write to us, outlining your aspirations in a cover letter and
            attaching your educational documents, such as diplomas, references
            from former employers, and letters of recommendation.
          </p>
          <p className="description-medium">
            For all career-related questions, you can contact our manager:
          </p>
          <a href="/#" className="mail description-demibold">nadia@uniferx.com</a>
        </div>
      </div>
      <CareerPageForm />
    </div>
  );
};
